
import { defineComponent, onMounted, reactive, toRefs } from 'vue'
import { useRoute } from 'vue-router'
import { ElMessageBox } from 'element-plus'
import { wuRequest } from '@/service'

import { url } from '@/service/config'
import JianDanLb from '@/components/JianDanLb.vue'

//import HelloWorld from '@/components/HelloWorld.vue' // @ is an alias to /src

export default defineComponent({
    components: { JianDanLb },
    setup() {
        let t = reactive<any>({
            data: {},
            menu: [
                { id: 49, name: '专业设备', active: true },
                { id: 50, name: '产品证书', active: false }
            ],
            // 专业设备
            sb: [],
            //证书
            zs: [],
            // 页脚下面的轮播
            footCarouse: [],
            footCurrentIndex: 0,
            footCurrentPage: { start: 0, end: 2 },
            url
        })
        const route = useRoute().query
        onMounted(async () => {
            // 保持菜单更新一直在顶
            document.body.scrollTop = document.documentElement.scrollTop = 0
            let res = await wuRequest.get({
                url: '/gt-test'
            })

            if (route.id === '49') {
                t.menu[0].active = true
                t.menu[1].active = false
            } else {
                t.menu[0].active = false
                t.menu[1].active = true
            }

            if (res.data.code === 10001) {
                t.data = res.data.data.data
            } else {
                ElMessageBox.alert('数据请求错误，请稍后重试', '数据异常', {
                    confirmButtonText: 'OK'
                })
                return false
            }
        })
        const changeMenu = (id: number) => {
            t.menu.map((item: any, index: any) => {
                if (index === id) {
                    item.active = true
                } else {
                    item.active = false
                }
            })
        }
        const showDesc = (index: number) => {
            if (t.data.listDesc.权威中心[index].active) {
                alert(1)
                t.data.showData.权威中心[index].active = false
            } else {
                t.data.listDesc.权威中心.map((item: any) => {
                    item.active = false
                })
                t.data.listDesc.权威中心[index].active = true
            }
        }

        return { ...toRefs(t), changeMenu, showDesc }
    }
})
